import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctDecimals, FctValue } from '../../../../Fct/generics';
import { FaMinus } from 'react-icons/fa';
import { supportedContracts } from '../constants';
export var Subtract = createPlugin({
    protocol: 'TOKEN_MATH',
    type: 'CALCULATOR',
    method: 'sub',
    description: 'Subtract amount2 from amount1',
    supportedContracts: supportedContracts,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                amount1: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaMinus }),
                decimals1: new FctDecimals({}),
                amount2: new FctValue({ destination: 'wei_amount', isPreview: true }),
                decimals2: new FctDecimals({}),
                decimalsOut: new FctDecimals({}),
            },
        },
        output: {
            result: new FctValue({
                innerIndex: 0,
            }),
        },
    }); },
});
